import React from 'react';
import { connect } from 'react-redux';

import AutoSuggesterInput from 'src/app/components/AutoSuggesterInput';
import {
  cityBlur,
  cityChange, cityFocus, citySetValidationMessage,
  citySuggestionsGet,
  citySuggestionsReset
} from 'src/app/redux/actions/registration/experience/experienceCity';


class ExperienceCity extends React.Component {

  renderSuggestion = (suggestion) => (<p data-test="text-city-suggestion">{ suggestion }</p>);

  clearSuggestions = () => {
    const { dispatch } = this.props;

    dispatch(citySuggestionsReset());
  };

  getSuggestions = ({ value }) => {
    const { dispatch, isPoland } = this.props;
    dispatch(citySuggestionsGet(value, isPoland));
  };

  setCity = (target, value) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { validationMessage } = target;

    dispatch(cityChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onChange = ({ target }, { newValue }) => {
    this.setCity(target, newValue);
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(cityFocus());
  };

  onBlur = ({ target }, { highlightedSuggestion }) => {
    if (highlightedSuggestion || !target) {
      return;
    }
    const { suggestions } = this.props;

    if (suggestions.length !== 0) {
      this.setCity(target, suggestions[0]);
      return;
    }

    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = target;

    dispatch(cityBlur(markedAsWrong, validationMessage));
    dispatch(citySetValidationMessage(validationMessage));
  };


  render() {
    const { onChange, onBlur, onFocus, getSuggestions, clearSuggestions, renderSuggestion } = this;
    const { suggestions, value, validationMessage, focus, markedAsWrong, apiError, inputRef, sending } = this.props;

    return (
      <AutoSuggesterInput id="city"
                          label="Miasto"
                          required
                          inputRef={ inputRef }
                          disabled={ sending }
                          getSuggestionValue={ (suggestion) => suggestion }
                          dataTest="input-city"
                          { ...{
                            markedAsWrong,
                            suggestions,
                            value,
                            validationMessage,
                            focus,
                            apiError,
                            renderSuggestion,
                            onChange,
                            onBlur,
                            onFocus,
                            getSuggestions,
                            clearSuggestions
                          }
                          }
      />
    );
  }
}

const mapStateToProps = (store) => ({
  ...store.experienceCityReducer,
  ...store.experienceFormReducer,
  countryId: store.experienceCountryReducer.id,
  isPoland: store.experienceCountryReducer.isPoland
});

export default connect(mapStateToProps)(ExperienceCity);
